import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { Stack, Typography } from '@lyearn/ui';
import { FilterItemProps } from '@/components/Filter/FilterItem/types';

import { UserFilterItemType } from '../hooks/useUsersFilter';

function BatchFilterItem(props: FilterItemProps) {
  const { isSelected, option } = props;
  const batch = option as unknown as UserFilterItemType;
  const { isMobile } = useScreen();

  const { t } = useTranslation();

  return (
    <Stack>
      <Typography
        className="xs:body-short-01 truncate ms-12"
        color={isSelected ? 'text-text-primary' : 'text-text-secondary'}
        title={option.label}
        variant="body-short-02">
        {option.label}
      </Typography>
    </Stack>
  );
}

export default React.memo(BatchFilterItem);
